import { ErrorResponse } from 'request-dot-js/types'

export class FetchError extends Error {
  constructor(public res: ErrorResponse, message?: string) {
    super(message)
  }
}
